<template>
  <div>
    <div class="sub_top">
      <div class="sub_tit">
        <div class="sub_tit_inner">
          <h2>프로토콜</h2>
        </div>
      </div>
    </div>

    <div class="ptc_container">
      <div class="info_section">
        <div class="info_txt">
          <span class="lbtx">프로토콜이란?</span>
          <p class="txt_typ_lg"><span class="txt_ib">측정/분석을 위한 </span> <span class="txt_ib">표준화된 절차/지침서</span></p>
          <hr class="hr_line"/>
          <p class="txt_typ_3">전문가의 노하우가 측정·분석 프로토콜의 요소 항목과 메타정보를 포함한 데이터입니다.</p>
          <p class="txt_typ_3">프로토콜 플랫폼에서는 <strong>트리와 위키 2가지의 형식</strong>으로 프로토콜을 정리하고 사용할 수 있습니다.</p>
          <a href="#none" class="info_txt_btn" @click="handleClick">프로토콜 만들어 보기</a>
        </div>
        <div class="info_graphic">
          <div class="info_graphic_img">
            <img :src="require(`@/style/new/images/info/protocol_01.png`)" alt=""/>
          </div>
        </div>
      </div>

      <div class="info_section">
        <div class="info_txt">
          <span class="lbtx">CheckPoint 01</span>
          <p class="txt_typ_md"><span class="colr">[트리보기]</span> 에서는 분석을 위한 전체적인 정보를 확인할 수 있습니다.</p>
        </div>
        <div class="info_graphic">
          <div class="info_graphic_img">
            <img :src="require(`@/style/new/images/info/protocol_02.png`)" alt=""/>
          </div>
        </div>
      </div>

      <div class="info_section">
        <div class="info_txt">
          <span class="lbtx">CheckPoint 02</span>
          <p class="txt_typ_md"><span class="colr">[위키보기]</span> 에서는 각 항목의 상세한 정보를 확인할 수 있습니다.</p>
        </div>
        <div class="info_graphic">
          <div class="info_graphic_img">
            <img :src="require(`@/style/new/images/info/protocol_03.png`)" alt=""/>
          </div>
          <p class="desc_txt typ1">프로토콜 플랫폼은 복잡한 소재 제작과정을 쉽고 편리하게 제작할 수 있는 프로토콜 에디터 기능을 제공하여, 나만의 연구 과정을 쉽게 정리 할 수
            있습니다.</p>
          <p class="desc_txt typ2">또한 전문가들이 <span class="colr">검증하고 공개한 다양한 공정들을 검색하고 활용</span>할 수 있어, 더욱 효율적인 연구를 할 수
            있도록
            도와줍니다.</p>
        </div>
      </div>
    </div>

    <div class="btm_banner">
      <div class="btm_banner_inner">
        <p>효율적인 연구를 하기위한 프로토콜을 만들어보세요.</p>
        <a href="#none" class="linkbtn" @click="handleClick">프로토콜 만들어 보기</a>
      </div>
    </div>
  </div>
  <!-- container : E -->

  <!-- 플랫폼, 프로토콜 설명 페이지 -->
  <!--  <div class="pb-md-5">-->
  <!--    <section>-->
  <!--      <b-container class="mb-5 pb-lg-3">-->
  <!--        <content-header title="프로토콜이란?" />-->
  <!--        <p class="mt-lg-5 text-14 text-lg-16 text-center lh-170 text-gray-6">-->
  <!--          전문적인 측정·분석을 위한 약속된 절차로-->
  <!--          <strong class="fw-600">측정분석이 표준화된 절차이자 지침서</strong>-->
  <!--          를 의미합니다.<br />-->
  <!--          전문가의 노하우가 측정·분석 프로토콜의 요소 항목과 메타정보를 포함한 데이터입니다.-->
  <!--        </p>-->
  <!--      </b-container>-->

  <!--      <div class="py-5" :style="{ backgroundColor: '#F2F7FE' }">-->
  <!--        <middle-container>-->
  <!--          <b-row class="mx-lg-n1 mx-xl-n4">-->
  <!--            <b-col class="px-lg-1 px-xl-4 mb-4 mb-lg-0 text-center" cols="6" lg="3" v-for="i in 4" :key="i">-->
  <!--              <img :src="require(`@/assets/platform/protocol/info-${i}.png`)" class="w-100 d-xl-block" />-->
  <!--            </b-col>-->
  <!--          </b-row>-->
  <!--        </middle-container>-->
  <!--      </div>-->
  <!--    </section>-->
  <!--    <section class="my-5 py-5">-->
  <!--      <h1 class="text-center text-18 text-md-26 fw-600">측정분석의 프로토콜화</h1>-->
  <!--      <middle-container class="mt-5 pt-5">-->
  <!--        <img src="@/assets/platform/protocol/diagram.png" class="w-100 d-xl-block" />-->
  <!--      </middle-container>-->
  <!--    </section>-->
  <!--  </div>-->
</template>

<script>
import MiddleContainer from "@/components/platform/MiddleContainer";
import ContentHeader from "@/components/platform/ContentHeader";

export default {
  components: {
    MiddleContainer,
    ContentHeader,
  },
  methods: {
    handleClick() {
      let test = this.$store.state.user;
      // console.log( "this.user", this.user )
      if (this.user && !this.user.admin && !this.user.assistant && !this.user.committee && !this.user.super && !this.user.generalManager) {
        window.alert("일반 유저는 에디터 접근이 불가합니다.");
      } else if (this.user) {
        window.open(this.$router.resolve("/protocol/gate?editorType=gate&listSearchType=recentList").href);
      } else {
        this.$router.push("/account/login");
      }
    },
  },
  data() {
    return {}
  }
};
</script>

<style lang="scss" scoped></style>
